export default {
    methods: {
        displayError(error) {
            const environment = process.env.NODE_ENV

            if (error.response.status === 419 || error.response.status === 401) {
                return;
            }

            if (environment === 'development') {
                this.$toasted.show(error)
            } else {
                this.$toasted.show('We\'re sorry there has been an error processing your request')
            }
        }
    }
}
